import { z } from 'zod';

/**
 * Validated build-time environment.
 *
 * Vite exposes only `VITE_*` variables to client code and inlines them at build
 * time. Everything here ships to the browser, so no secrets belong in it.
 */
const envSchema = z.object({
  VITE_API_URL: z.url().default('http://localhost:4000'),
  VITE_API_VERSION: z.string().default('v1'),
  VITE_APP_NAME: z.string().default('BULK3.com Admin'),
  /// Storefront origin. Only used to show a merchandiser the URL their SEO
  /// edits will actually appear under; the admin never calls it.
  VITE_SITE_URL: z.url().default('http://localhost:3000'),
});

const parsed = envSchema.safeParse({
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_API_VERSION: import.meta.env.VITE_API_VERSION,
  VITE_APP_NAME: import.meta.env.VITE_APP_NAME,
  VITE_SITE_URL: import.meta.env.VITE_SITE_URL,
});

if (!parsed.success) {
  throw new Error(
    `Invalid environment configuration:\n${z.prettifyError(parsed.error)}\n` +
      'Check .env against .env.example.',
  );
}

export const env = parsed.data;

/** Fully-qualified base for versioned API routes, e.g. http://localhost:4000/api/v1 */
export const apiBaseUrl = `${env.VITE_API_URL}/api/${env.VITE_API_VERSION}`;

/**
 * Origin serving publicly readable assets.
 *
 * Product images are stored as root-relative URLs (`/static/…`) so they survive
 * a change of hostname; the browser needs the origin prefixed back on.
 */
export const apiBaseOrigin = env.VITE_API_URL;

/** Storefront origin, used to render the search-result preview in the product form. */
export const siteOrigin = env.VITE_SITE_URL.replace(/\/$/, '');
